import React from 'react';
import { FormikProps } from 'formik';
import { DividerSection } from '../../../../global/components/layout/divider-section';
import { PhoneField } from '../../../../global/components/form-element/phone-input';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { FormGroup } from '../../../../global/components/layout/form-group';


interface PhoneProps {
	labelSetting: LabelSettingProps,
	formProps: FormikProps<any>,
	hideBusiness?: boolean,
}

export function PhoneInfo(props: PhoneProps) {

	const isBusiness = true;

	return (

		<DividerSection sectionText={props.labelSetting.phoneSectionTitle}>
			<FormGroup>
				<PhoneField
					label={props.labelSetting.cellPhoneLabel}
					countryFieldName='mobile_phone_country_code'
					phoneFieldName='mobile_phone_formated'
					extFieldName='mobile_phone_extension'
					ext={!isBusiness}
					formProps={props.formProps}
				/>
				<PhoneField
					label={props.labelSetting.homePhoneLabel}
					countryFieldName='home_phone_country_code'
					phoneFieldName='home_phone_formated'
					extFieldName='home_phone_extension'
					ext={!isBusiness}
					formProps={props.formProps}

				/>
				{!props.hideBusiness && <PhoneField
					label={props.labelSetting.businessPhoneLabel}
					countryFieldName='business_phone_country_code'
					phoneFieldName='business_phone_formated'
					extFieldName='business_phone_extension'
					extLabel={props.labelSetting.extensionLabel}
					ext={isBusiness}
					formProps={props.formProps}

				/>}

			</FormGroup>
		</DividerSection>
	);
}

PhoneInfo.defaultProps = {
	hideBusiness: false,

};
